(ns motorsaif.web.admin.home
  (:require ;; [cljs.core.async :refer [go]]
   ;; [cljs.core.async.interop :refer-macros [<p!]]
   ;; [cljs.pprint]
   [goog.string :refer [format]] ;; [cljs.core.async :refer [go]]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.web.pwa :as pwa]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [reagent.core :as r]))

(defn root []
  [:div.container
   ;; [forms/test-ui]
   [:h1.title "Admin"]
   [:p "Online: "
    (str @(subscribe [:online-users]))]
   [:div.wrap
    [:a.btn.primary.small
     {:href (routes/path-for :admin-localization)}
     "Localization"]
    (doall (for [[k title] [[:users "Users"]
                            [:businesses "Businesses"]
                            [:requests "Requests"]]]
             (let [table @(subscribe [:admin-data k])
                   table-count (count table)]
               ^{:key k}
               [:a.btn.primary.small
                {:href (routes/path-for :admin-table {:table k})}
                (format "%s (%s)" title table-count)])))]
   ;; [pwa/debug]
   ])
